export default __webpack_public_path__ + "static/media/BrainBreak cards91.9fd936ed.png";